import styled from '@emotion/styled'
import { TheWestLiveBroadcast } from '@news-mono/web-common'
import { FillProperty } from 'csstype'
import { colors } from '../../../__styling/settings/colors'
import { ThemeMargins } from '../../../__styling/settings/metrics'
import { breakpoint } from '../../../__styling/style-functions'
import { calcRem } from '../../../__styling/style-functions/calc-rem'
import { themedValue } from '../../../__styling/themed-value'
import {
    StyledControlButton,
    StyledPlayIcon,
    StyledStopIcon,
} from '../TheWestLivePlayer/TheWestLivePlayerSkin/Components/ControlButton/ControlButton.styled'
import { SponsoredLogoContainer } from '../TheWestLiveStickyBanner/TheWestLiveStickyBanner.styled'

const switchAtViewport = 'sm'

interface StyledWestLiveBillboardWrapperProps {
    broadcast?: TheWestLiveBroadcast
    verticalSpacing?: [keyof ThemeMargins, keyof ThemeMargins] | undefined // [marginTop,marginBottom]
}
export const StyledWestLiveBillboardWrapper = styled(
    'div',
)<StyledWestLiveBillboardWrapperProps>(
    ({ verticalSpacing, theme, broadcast = 'live' }) => ({
        display: 'none',

        [breakpoint(switchAtViewport)]: {
            display: 'block',
            backgroundColor: themedValue(theme, {
                thewest:
                    broadcast === 'catchup'
                        ? colors.thewest.westblue
                        : colors.white,
                perthnow:
                    broadcast === 'catchup'
                        ? colors.perthnow.greyBasalt
                        : colors.white,
                fallback: colors.white,
            }),
            position: 'relative',
            overflow: 'hidden',
            height: calcRem(160),
            marginTop: calcRem(
                verticalSpacing ? theme.margins[verticalSpacing[0]] : 0,
            ),
            marginBottom:
                verticalSpacing &&
                verticalSpacing[0] &&
                calcRem(theme.margins[verticalSpacing[1]]),
        },
    }),
)

export const StyledWestLiveBillboardContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    position: 'relative',
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',

    [`& ${SponsoredLogoContainer}`]: {
        borderLeftWidth: '1px',
        borderLeftStyle: 'solid',
        borderLeftColor: themedValue(theme, {
            thewest: colors.thewest.westblue,
            perthnow: colors.black,
            fallback: undefined,
        }),
        paddingLeft: calcRem(16),
        height: 'calc(100% - 30px)',

        [breakpoint(switchAtViewport)]: {
            paddingLeft: calcRem(30),
            height: 'calc(100% - 60px)',
        },
    },
}))

export const StyledBannerImage = styled('img')({
    '&.full': {
        display: 'none',
    },

    // The image of presenter is repositioned at higher viewports
    [breakpoint(switchAtViewport)]: {
        '&.mobile': {
            display: 'none',
        },
        '&.full': {
            display: 'block',
        },
    },
})

export const StyledWestLiveBillboardLogoAndPlayerContainer = styled('div')<{
    broadcast?: TheWestLiveBroadcast
}>(({ theme, broadcast }) => ({
    alignItems: 'center',
    display: 'flex',

    [`& ${StyledControlButton}`]: {
        backgroundColor: themedValue(theme, {
            perthnow:
                broadcast === 'catchup'
                    ? colors.white
                    : colors.perthnow.redRuby,
            fallback:
                broadcast === 'catchup'
                    ? colors.white
                    : colors.thewest.westblue,
        }),

        '&:hover': {
            backgroundColor:
                broadcast === 'catchup' ? colors.white : colors.black,
            transform: 'none',

            [`& ${StyledPlayIcon}, & ${StyledStopIcon}`]: {
                fill: broadcast === 'catchup' ? colors.black : undefined,
            },
        },
    },

    [`& ${StyledPlayIcon}, & ${StyledStopIcon}`]: {
        fill: themedValue(theme, {
            perthnow:
                broadcast === 'catchup'
                    ? colors.perthnow.greyBasalt
                    : colors.white,
            fallback:
                broadcast === 'catchup'
                    ? colors.thewest.westblue
                    : colors.white,
        }) as FillProperty,
    },

    [breakpoint(switchAtViewport)]: {
        paddingRight: calcRem(30),
    },
}))

export const StyledWestLiveBillboardPlayerContainer = styled('div')(
    ({ theme }) => ({
        padding: `0 ${calcRem(theme.margins.sm)}`,
        width: calcRem(58),
    }),
)

export const StyledSponsorLogo = styled('img')({
    width: calcRem(46),

    [breakpoint(switchAtViewport)]: {
        width: calcRem(150),
    },
})
